import * as React from 'react';
import cn from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { useTheme } from '../../../theme';
import { MOBILE_MIN_WIDTH } from '../../../utils';

import Dropdown from '../../../Dropdown';
import SlideBottom from '../../../SlideBottom';

export type ControlType = {
	icon: React.ReactNode;
	name: string;
	onClick: () => void;
};

interface Props {
	controls: Array<ControlType>;
	isOpened: boolean;
	outsideClickIgnoreClass?: string;
	onClose: () => void;
}

const FlightInfoCardControls: React.FC<Props> = ({ controls, isOpened, onClose, outsideClickIgnoreClass }) => {
	const { FlightInfoCardControls: css } = useTheme('FlightInfoCard');

	const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE_MIN_WIDTH}px)` });

	const renderControls = React.useMemo(
		() => (
			<div className={cn(css.controls)}>
				{controls.map(control => (
					<div
						key={control.name}
						className={cn(css.controls__item)}
						onClick={() => {
							onClose();
							control.onClick();
						}}
					>
						<span className={cn(css.controls__img)}>{control.icon}</span>
						{control.name}
					</div>
				))}
			</div>
		),
		[controls]
	);

	return isMobile ? (
		<SlideBottom isOpen={isOpened} onClose={onClose}>
			{renderControls}
		</SlideBottom>
	) : (
		<Dropdown isOpen={isOpened} onClose={onClose} outsideClickIgnoreClass={outsideClickIgnoreClass}>
			{renderControls}
		</Dropdown>
	);
};

export default FlightInfoCardControls;
